/* ----------------- Types --------------- */
import type { Confidence } from "@memorang/types";
import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import Button from "../../Button";

type Props = {
	handleConfidenceProvided: (c: Confidence) => void;
	handleAiFeedbackProvided: (confidence: Confidence) => void;
	handleGenerateFeedback: (callback: () => void) => Promise<void>;
	cta: string;
};
const SubmitAnswerDynamic = ({
	handleConfidenceProvided,
	handleAiFeedbackProvided,
	handleGenerateFeedback,
	cta,
}: Props) => {
	const handleSubmitResponse = async (confidence: Confidence) => {
		handleConfidenceProvided(confidence);
		await handleGenerateFeedback(() => handleAiFeedbackProvided(confidence));
	};

	const { isMobile } = useDevice();

	return (
		<Box flex={1} alignItems="center">
			<Box maxWidth={isMobile ? "100%" : 400} width={"100%"}>
				<Button
					mode="contained"
					onPress={() => {
						handleSubmitResponse(50);
					}}
				>
					{cta}
				</Button>
			</Box>
		</Box>
	);
};

export default SubmitAnswerDynamic;
